import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Image } from 'foundations-components/transitional/components/Image';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo } from 'react';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { DetailsPageCard } from './DetailsPageCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Section({
  expandable = true,
  label,
  tooltip,
  items
}) {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const handleTrackInteraction = useCallback(eventProps => {
    trackInteraction(Object.assign({
      section: 'product info list'
    }, eventProps));
  }, [trackInteraction]);
  const hasIcons = items.some(item => !!item.icon);
  const renderedItems = useMemo(() => {
    if (items.length === 1) {
      const item = items[0];
      return hasIcons ? /*#__PURE__*/_jsx(MediaObject, {
        itemLeft: /*#__PURE__*/_jsx(Image, {
          marginBlockStart: "50",
          blockSize: "20px",
          minInlineSize: "20px",
          src: item.icon,
          alt: item.name
        }),
        children: item.name
      }, item.key || item.name) : item.name;
    }
    return hasIcons ? /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "100",
      children: items.map(item => /*#__PURE__*/_jsx(MediaObject, {
        itemLeft: /*#__PURE__*/_jsx(Image, {
          marginBlockStart: "50",
          blockSize: "20px",
          minInlineSize: "20px",
          src: item.icon,
          alt: item.name
        }),
        children: item.name
      }, item.key || item.name))
    }) : /*#__PURE__*/_jsx(List, {
      styled: true,
      children: items.map(item => /*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "-500",
        children: item.name
      }, item.key || item.name))
    });
  }, [hasIcons, items]);
  if (!expandable) {
    return /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "200",
      children: [tooltip ? /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          children: label
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: tooltip
        })]
      }) : /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        typography: "heading-100",
        children: label
      }), renderedItems]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: items.length <= 3 ? '200' : '0',
    children: [tooltip ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      marginBlockEnd: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        children: label
      }), /*#__PURE__*/_jsx(HelpIcon, {
        title: tooltip
      })]
    }) : /*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "200",
      typography: "heading-100",
      children: label
    }), /*#__PURE__*/_jsx(ExpandableText, {
      animate: false,
      buttonAlign: "left",
      fadeOutHeight: 0,
      hideButtonCaret: true,
      maxHeight: hasIcons ? 120 : 110,
      onExpandButtonClick: () => handleTrackInteraction({
        action: 'click expand section',
        value: label
      }),
      onCollapseButtonClick: () => handleTrackInteraction({
        action: 'click collapse section',
        value: label
      }),
      expandButtonText: /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-interactive-default",
        textDecoration: "underline",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productCredentialsCard.expandButtonText"
        })
      }),
      collapseButtonText: /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-interactive-default",
        textDecoration: "underline",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productCredentialsCard.collapseButtonText"
        })
      }),
      children: renderedItems
    })]
  });
}
export function ProductInfoList({
  sections
}) {
  if (!sections.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(DetailsPageCard, {
    name: "icons list",
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "400",
      children: sections.map(({
        expandable,
        label,
        tooltip,
        items
      }) => /*#__PURE__*/_jsx(Section, {
        expandable: expandable,
        label: label,
        tooltip: tooltip,
        items: items
      }, label))
    })
  });
}